export default {
  AGREEMENT_PRICE_INCREASE: 'agreement-price-increase',
};
